import { render, staticRenderFns } from "./base-radio.vue?vue&type=template&id=16377f3e&"
import script from "./base-radio.vue?vue&type=script&lang=js&"
export * from "./base-radio.vue?vue&type=script&lang=js&"
import style0 from "./base-radio.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports